import React from 'react';
import UserContext from '../../contexts/UserContext';
import get from 'lodash/get';

export default function PrivateBlock(props) {
  const { allowedGroups = [], disallowedGroups, onIsAllowed } = props;
  const { currentUser } = React.useContext(UserContext);
  const userGroup = get(currentUser, 'memberInfo.role.group');
  let allowed = allowedGroups.includes(userGroup);
  if (disallowedGroups) {
    allowed = !disallowedGroups.includes(userGroup);
  }

  React.useEffect(() => {
    onIsAllowed && onIsAllowed(allowed);
  }, [allowed]);

  if (allowed) return props.children;

  return null;
}
